import {Box, SvgIcon, SvgIconProps} from "@mui/material";

export interface UsersIconProps extends SvgIconProps {
    scolor?: string;
}

const UsersIcon = ({ scolor = "#78909C", ...props }: UsersIconProps) => {
    return (
        <SvgIcon style={{fill: "none"}} {...props}>
            <path d="M0 0h24v24H0V0"/>
            <Box strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                 d="M12 4.354a4 4 0 1 1 0 5.292m0 5.157A6 6 0 0 1 21 20v1H3v-1a6 6 0 1 1 12 0v1M11.828 9.828a4 4 0 1 1-5.656-5.656 4 4 0 0 1 5.656 5.656Z"
                 component="path" sx={{stroke: scolor,
                        '&:hover': {
          stroke: 'white', // Background color on hover
        },
            }}/></SvgIcon>
    );
};

export default UsersIcon;